import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SweetalertService } from '../providers/sweetalert.service';

@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {

    constructor(private sweetalertService: SweetalertService) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        let req = request;
        let ignoreInterceptor = false;

        if (req.headers.has('ignore-interceptor')) {
            ignoreInterceptor = JSON.parse(req.headers.get('ignore-interceptor'));
            req = req.clone({ headers: req.headers.delete('ignore-interceptor') });
        }

        return next.handle(req).pipe(
            tap({
                error: (e) => {
                    if (!ignoreInterceptor) {
                        const response = e.error;
                        this.sweetalertService.error(
                            'Error',
                            response.message || response.error
                        );
                    }
                },
            })
        );
    }
}
